import { ScanAnalyticsGraphData } from '../../../../../../interfaces/entity-dashboard/ScanAnalyticsData';
import { getLabelForPeriod } from '../../../../../../../shared/features/charts';

export type ScanAnalyticsGraphInfo = {
  labels: string[];
  newScansValues: number[];
};

export const getGraphInfo = (
  scanAnalyticsGraphData: ScanAnalyticsGraphData,
): ScanAnalyticsGraphInfo => {
  const { groupBy, data } = scanAnalyticsGraphData;

  return data.reduce<ScanAnalyticsGraphInfo>(
    (acc, point) => {
      const label = getLabelForPeriod(point.periodFrom, point.periodTo, groupBy);

      acc.labels.push(label);
      acc.newScansValues.push(point.newScans);

      return acc;
    },
    { labels: [], newScansValues: [] },
  );
};
